module.exports = __webpack_public_path__ + "static/media/lock_icon.a804dbc3.svg";